import { createFileRoute, Outlet } from "@tanstack/react-router";

import SearchExpiredModal from "@/components/SearchExpiredModal/SearchExpiredModal";
import { PurchaseStateContextProvider } from "@/contexts/PurchaseStateContext";
import { SearchDataMissingErrorBoundary } from "@/errors/SearchDataMissingErrorBoundary";
import { HotelDataProvider } from "@/features/hotels/contexts/HotelDataContext";
import { useHotelSearch } from "@/features/hotels/hooks/useHotelSearch";
import { useSearchExpiry } from "@/hooks/useSearchExpiry";

export const Route = createFileRoute("/_authenticated/hotels/_hotels")({
  component: HotelsRoute,
});

function HotelsRoute() {
  return (
    <SearchDataMissingErrorBoundary>
      <RouteComponent />
    </SearchDataMissingErrorBoundary>
  );
}

function RouteComponent() {
  // this is only to initiate cache
  useHotelSearch();
  const navigate = Route.useNavigate();
  const { isExpired, handleResetExpiredSearch } = useSearchExpiry("hotel");

  const handleRefresh = () => {
    handleResetExpiredSearch();
    navigate({ to: "/hotels/list" });
  };

  const handleNewSearch = () => {
    handleResetExpiredSearch();
    navigate({ to: "/hotels/search" });
  };

  return (
    <HotelDataProvider>
      <PurchaseStateContextProvider>
        <Outlet />
        <SearchExpiredModal
          open={isExpired}
          type="hotel"
          onRefresh={handleRefresh}
          onNewSearch={handleNewSearch}
        />
      </PurchaseStateContextProvider>
    </HotelDataProvider>
  );
}
